<template>
  <div class="instructionsCom ashComWrap">
    <div class="comTitle">
      <h4></h4>
      <el-row>
        <template v-if="showEdit">
          <el-button size="mini" @click="changeBtn" :disabled="loading"
            >取消</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="onSubmit"
            style="margin-right: 70px"
            :loading="loading"
            >保存</el-button
          >
        </template>
        <el-button v-else type="primary" size="mini" @click="showEditFun"
          >编辑</el-button
        >
      </el-row>
    </div>
    <div class="comContentBox">
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        size="mini"
        style="width: 60%; margin-left: 20px"
      >
        <el-form-item label="是否开放预约">
          <el-switch v-if="showEdit" v-model="form.openness"></el-switch>
          <p v-else>{{ detailsInfo.open ? "是" : "否" }}</p>
        </el-form-item>
        <el-form-item label="安全负责人">
          <el-select
            v-if="showEdit"
            v-model="form.safetyUser"
            placeholder="请选择安全负责人"
            value-key="userId"
            clearable
          >
            <el-option
              v-for="item in safetyUserList"
              :key="item.userId"
              :label="item.userName"
              :value="item"
            >
            </el-option>
          </el-select>
          <p v-else>{{ detailsInfo.safetyUsername }}</p>
        </el-form-item>
        <el-form-item label="联系方式">
          <p>
            {{ showEdit ? form.safetyUser.phone : detailsInfo.safetyUserPhone }}
          </p>
        </el-form-item>
        <el-form-item label="保洁负责人">
          <el-select
            v-if="showEdit"
            v-model="form.cleaningUser"
            placeholder="请选择保洁负责人"
            value-key="userId"
            clearable
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.userName"
              :value="item"
            >
            </el-option>
          </el-select>
          <p v-else>{{ detailsInfo.cleanUsername }}</p>
        </el-form-item>
        <el-form-item label="联系方式">
          <p>
            {{
              showEdit ? form.cleaningUser.phone : detailsInfo.cleanUserPhone
            }}
          </p>
        </el-form-item>
        <el-form-item label="区域位置">
          <p>{{ treeActive.treeTitle }}</p>
        </el-form-item>
        <el-form-item label="区域编号">
          <p>{{ treeActive.id }}</p>
        </el-form-item>
        <el-form-item label="最近保洁时间">
          <p>{{ detailsInfo.latestMaintenanceActTime }}</p>
        </el-form-item>
        <el-form-item label="最近巡检时间">
          <p>{{ detailsInfo.latestInspectionActTime }}</p>
        </el-form-item>
        <el-form-item label="未处理工单">
          <p>{{ detailsInfo.notProcessedRepairOrder }}</p>
        </el-form-item>
        <el-form-item label="用途">
          <el-input
            v-if="showEdit"
            type="textarea"
            :rows="5"
            resize="none"
            v-model.trim="form.desc"
          ></el-input>
          <p v-else>{{ detailsInfo.use }}</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt, judgeAuthority } from "@/assets/js/utils";
export default {
  props: {
    treeActive: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showEdit: false,
      form: {
        openness: true,
        cleaningUser: {},
        safetyUser: {},
        desc: "",
      },
      detailsInfo: {},
      userList: [],
      safetyUserList: [],
      loading: false,
    };
  },
  watch: {
    treeActive: {
      handler() {
        if (this.treeActive.id) {
          this.showEdit = false;
          this.getDetails();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    showEditFun() {
      this.form.openness = this.detailsInfo.open;
      this.form.desc = this.detailsInfo.use;
      this.form.cleaningUser = this.detailsInfo.cleanUserId
        ? this.userList.find((v) => {
            return v.userId === this.detailsInfo.cleanUserId;
          }) ?? {}
        : {};
      this.form.safetyUser = this.detailsInfo.safetyUserId
        ? this.safetyUserList.find((v) => {
            return v.userId === this.detailsInfo.safetyUserId;
          }) ?? {}
        : {};

      this.showEdit = true;
    },
    changeBtn() {
      this.form.cleaningUser = {};
      this.form.safetyUser = {};
      this.showEdit = false;
    },
    async getDetails() {
      let res = await api.BMSInstructionsGetDetails({
        assetId: this.treeActive.id,
      });

      if (res && res.data.code == 200) {
        this.detailsInfo = res.data.data;
        for (let key in this.detailsInfo) {
          if (
            key === "latestInspectionActTime" ||
            key === "latestMaintenanceActTime"
          ) {
            this.detailsInfo[key] = this.detailsInfo[key]
              ? dateFtt("yyyy-MM-dd hh:mm", new Date(this.detailsInfo[key]))
              : "-";
          }
        }
      }
    },
    async getUserList() {
      let res = await api.projectGetUserListByPower({
        permission: "houqinguanli:baoyangguanli:maintainPlan:edit",
      });
      if (res && res.data.code == 200) {
        this.userList = res.data.data.filter((v) => {
          return v.userName && v.phone;
        });
      }
    },
    async getSafetyUserList() {
      let res = await api.publicGetAdminUser({
        pageSize: 10000,
        page: 0,
      });
      if (res && res.status == 200) {
        this.safetyUserList = res.data.data.filter((v) => {
          return v.userName && v.phone;
        });
      }
    },

    async onSubmit() {
      this.loading = true;
      let res = await api.BMSInstructionsSetDetails({
        assetId: this.treeActive.id,
        open: this.form.openness,
        safetyUserId: this.form.safetyUser.userId ?? null,
        cleanUserId: this.form.cleaningUser.userId ?? null,
        use: this.form.desc ?? "",
      });
      if (res && res.data.code == 200) {
        setTimeout(() => {
          this.loading = false;
          this.showEdit = false;
          this.getDetails();
          this.$message.success("修改成功!");
        }, 500);
      } else {
        this.loading = false;
      }
    },
  },
  created() {
    this.getUserList();
    this.getSafetyUserList();
  },
};
</script>

<style lang="scss" scoped></style>
